// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__est51","type":"styles_type__YfpLv","choices":"styles_choices__1CljK"};